import { canUseDOM, getBaseUrl, getCurrentURL } from '@common/utils'
import constants from './constants'

export const Routes = {
  cart: '/cart',
  checkout: '/checkout',
  deviceDiagnostic: '/device-diagnostic',
  emailVerification: '/EmailVerification',
  invitationTrackNFC: '/invitation/track/on/nfc_dev_reg',
  lineRegisterThankyou: '/line/register-thankyou',
  main: '/',
  OCR: '/ocr',
  orderConfirmation: '/OrderConfirmation',
  products: '/products',
  profile: '/profile',
  profileAccount: '/profile#account',
  profileDevices: '/profile#devices',
  register: '/register',
  registerSuccess: '/register/success',
  registerOCRSuccess: '/ocr/success',
  shopCatalogue: '/shop/catalogue',
  smartSelection: '/shop/catalogue/promotion/smart-selection',
  supportReplace: '/support/replace',
  userLogin: '/user-login',
  upgradeCheckout: '/upgrade-checkout',
  upgradeOffer: '/upgrade-offer',
  upgradeOfferCart: '/upgrade-offer/cart',
  upgradeOfferCheckout: '/upgrade-offer/checkout'
}

export const Fragments = {
  delivery: 'delivery',
  account: 'account'
}

export const Name = {
  blank: '_blank'
}

export const Specs = {
  noOpener: 'noopener',
  noReferrer: 'noreferrer'
}

export function getDynamicPath(path, value, divider = '/') {
  return path + divider + value
}

export function getRoute(
  mainPath,
  isBaseURL = false,
  isCurrentUrl = false,
  params = null,
  fragment = null
) {
  let url = mainPath

  if (mainPath && isCurrentUrl) {
    const param = params !== null ? params : ''
    url = mainPath + '?' + getCurrentURL(param)
  }

  if (isBaseURL && mainPath) {
    url = getBaseUrl() + mainPath
  }

  if (mainPath && params && params.length > 0 && !isCurrentUrl) {
    url = mainPath + '?' + params.join('&')
  }

  if (isBaseURL && mainPath && params && params.length > 0) {
    url = getBaseUrl() + mainPath + '?' + params.join('&')
  }

  if (
    isBaseURL &&
    mainPath &&
    params &&
    params.length > 0 &&
    fragment !== null
  ) {
    url = getBaseUrl() + mainPath + '?' + params.join('&') + '#' + fragment
  }

  return url
}

export function goTo(
  mainPath,
  isBaseURL = false,
  isCurrentUrl = false,
  params = null,
  fragment = null
) {
  if (canUseDOM) {
    const route = getRoute(mainPath, isBaseURL, isCurrentUrl, params, fragment)
    if (!isIqosDomainSwitch(route)) {
      window.location.href = route
    }
  }
}

export function open(path, name = Name.blank, specs = null) {
  const specsList = specs && specs.length > 0 && specs.join(',')
  canUseDOM && window.open(path, name, specsList)
}

const isIqosDomainSwitch = route => {
  try {
    const routeUrl = new URL(route)
    const iqosUrl = new URL(constants.SITE_BASE_URL)
    const iqosphereUrl = new URL(constants.IQOSPHERE_SITE_BASE_URL)
    if (routeUrl && routeUrl.host !== window.location.host) {
      if (
        routeUrl.host === iqosUrl.host ||
        routeUrl.host === iqosphereUrl.host
      ) {
        window.dispatchEvent(
          new window.CustomEvent('ondomainswitch', { detail: { url: route } })
        )
        return true
      }
    }
  } catch {}
  return false
}
